// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._152tze3t{inset-block-start:var(--ds-space-0,0)}
._18m915vq{overflow-y:hidden}
._1bsb1gwv{width:360px}
._1bsb1mwr{width:95vw}
._1bsb1ogm{width:600px}
._1bsb1y37{width:5in}
._1bsbauwl{width:100vw}
._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}
._1e0c1txw{display:flex}
._1pbybfng{z-index:500}
._1q1l1bhr{--ds-elevation-surface-current:var(--ds-surface-overlay,#fff)}
._1reo15vq{overflow-x:hidden}
._4t3i1kxc{height:100vh}
._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}
._kqsw1n9t{position:fixed}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/drawer/dist/esm/compiled/drawer-panel/drawer-panel.compiled.css"],"names":[],"mappings":"AAAA,WAAW,qCAAqC;AAChD,WAAW,iBAAiB;AAC5B,WAAW,WAAW;AACtB,WAAW,UAAU;AACrB,WAAW,WAAW;AACtB,WAAW,SAAS;AACpB,WAAW,WAAW;AACtB,WAAW,sCAAsC;AACjD,WAAW,YAAY;AACvB,WAAW,WAAW;AACtB,WAAW,6DAA6D;AACxE,WAAW,iBAAiB;AAC5B,WAAW,YAAY;AACvB,WAAW,+CAA+C;AAC1D,WAAW,cAAc","sourcesContent":["._152tze3t{inset-block-start:var(--ds-space-0,0)}\n._18m915vq{overflow-y:hidden}\n._1bsb1gwv{width:360px}\n._1bsb1mwr{width:95vw}\n._1bsb1ogm{width:600px}\n._1bsb1y37{width:5in}\n._1bsbauwl{width:100vw}\n._1e02ze3t{inset-inline-start:var(--ds-space-0,0)}\n._1e0c1txw{display:flex}\n._1pbybfng{z-index:500}\n._1q1l1bhr{--ds-elevation-surface-current:var(--ds-surface-overlay,#fff)}\n._1reo15vq{overflow-x:hidden}\n._4t3i1kxc{height:100vh}\n._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}\n._kqsw1n9t{position:fixed}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
